import axios from 'axios';
import {
	Form,
	Link,
	redirect,
	useLoaderData,
	useParams,
} from 'react-router-dom';

import ChallengeQuestions from '../../components/ChallengeQuestions';
import { useUserStore } from '../../stores/userStore';

export async function loader(/*{ request, params }*/) {
	const { data } = await axios.get('/clients/security-questions');
	return data;
}

export async function action({ request /*params */ }) {
	const { signInWithoutCreds } = useUserStore.getState();
	const formData = await request.formData();
	const data = Object.fromEntries(formData);

	const errors = {};
	if (data.form === 'challQuestions') {
		const security_answers = [
			{ question_id: parseInt(data.question1, 10), answer: data.answer1 },
			{ question_id: parseInt(data.question2, 10), answer: data.answer2 },
			{ question_id: parseInt(data.question3, 10), answer: data.answer3 },
		];
		try {
			await signInWithoutCreds(data.username, security_answers);
			return redirect('/home');
		} catch (err) {
			errors.challQuestions = {
				message: 'Unable to save your choices',
			};
		}
	}

	return errors;
}

const ForgotPassword = () => {
	const { subTask } = useParams();
	const questions = useLoaderData();

	const showChallQuestLogin = subTask === 'questions';

	return (
		<div className="justify-center py-12 page">
			{showChallQuestLogin ? (
				<>
					<div className="sm:mx-auto sm:w-full sm:max-w-sm">
						<h2>Answer Challenge Questions</h2>
					</div>
					<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
						<Form className="space-y-6" method="post">
							<div className="form-control">
								<label htmlFor="username" className="label label-text">
									Username
								</label>
								<input
									id="username"
									name="username"
									type="text"
									autoComplete="username"
									required
									className="w-full input input-sm input-bordered"
								/>
							</div>
							<ChallengeQuestions questions={questions} />
							<div>
								<button
									className="text-white btn btn-primary btn-sm btn-block"
									name="form"
									value="challQuestions"
								>
									Sign In
								</button>
							</div>
						</Form>
					</div>
				</>
			) : (
				<>
					<div className="sm:mx-auto sm:w-full sm:max-w-sm">
						<h2>Forgot password</h2>
					</div>
					<div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
						<p>
							You can{' '}
							<Link to="/forgotPassword/reset" className="link link-primary">
								reset your password
							</Link>{' '}
							if you added a valid mobile number when you registered.
							Alternatively, you can{' '}
							<Link
								to="/forgotPassword/questions"
								className="link link-primary"
							>
								login with your username and challenge questions
							</Link>{' '}
							you answered when you registered.
						</p>
					</div>
				</>
			)}
		</div>
	);
};

export default ForgotPassword;
